import React, { useEffect, useState } from "react";
import { Button, Input, Modal } from "reactstrap";
import { useTranslation } from "react-i18next";

const GOLD = "#b8932f";
const STYLE = `
.ai-chip{display:inline-block;margin:0 6px 6px 0;padding:5px 12px;border:1px solid ${GOLD};border-radius:20px;color:${GOLD};background:transparent;font-size:.85rem;cursor:pointer}
.ai-chip:hover{background:rgba(184,147,47,.15)}
.ai-text{min-height:260px;font-size:1rem;line-height:1.5}
`;

// Finestra grande per scrivere le istruzioni all'AI. `onSubmit(testo)` restituisce una promessa con true se e' andata a buon fine.
const AiPromptModal = ({ open, onClose, title, intro, examples = [], placeholder, buttonLabel, busyLabel, onSubmit }) => {
  const { t } = useTranslation("cards");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setText("");
  }, [open]);

  const addExample = (example) => setText((prev) => (prev.trim() ? `${prev.trim()}\n${example}` : example));

  const submit = async () => {
    setBusy(true);
    try {
      if (await onSubmit(text.trim())) onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal isOpen={open} toggle={busy ? undefined : onClose} className="modal-lg" backdrop={busy ? "static" : true}>
      <style>{STYLE}</style>
      <div className="modal-header">
        <h5 className="modal-title">{title}</h5>
        <button aria-label={t("close")} className="close" type="button" disabled={busy} onClick={onClose}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        {intro && <p className="text-muted">{intro}</p>}
        <Input
          type="textarea"
          className="ai-text"
          value={text}
          disabled={busy}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
          maxLength={2000}
          autoFocus
        />
        <div className="d-flex justify-content-between small text-muted mt-1 mb-3">
          <span>{busy ? t("ai.wait") : ""}</span>
          <span>{text.length}/2000</span>
        </div>
        {examples.length > 0 && (
          <div>
            <div className="small text-muted mb-1">{t("ai.clickExample")}</div>
            {examples.map((example) => (
              <button key={example} type="button" className="ai-chip" disabled={busy} onClick={() => addExample(example)}>
                {example}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="modal-footer">
        <Button type="button" color="secondary" disabled={busy} onClick={onClose}>{t("cancel")}</Button>
        <Button type="button" color="primary" disabled={busy || text.trim().length < 5} onClick={submit}>
          {busy ? busyLabel : buttonLabel}
        </Button>
      </div>
    </Modal>
  );
};

export default AiPromptModal;
